import { TaskModel, TaskStatus } from "../../Models/Models";
import styles from "../../Styles/calendarDashboard.module.css";

const STATUS_CLASS: Record<TaskStatus, string> = {
  not_started: styles.statusNotStarted,
  in_progress: styles.statusInProgress,
  completed: styles.statusCompleted,
};

const PRIORITY_DOT_CLASS: Record<string, string> = {
  high: styles.priorityHigh,
  medium: styles.priorityMedium,
  low: styles.priorityLow,
};

type Props = {
  task: TaskModel;
  onClick: (task: TaskModel) => void;
  variant?: "month" | "week";
};

export default function CalendarEventChip({ task, onClick, variant = "month" }: Props) {
  const chipClass = variant === "week" ? styles.eventChipWeek : styles.eventChip;
  const statusClass = STATUS_CLASS[task.status] ?? styles.statusNotStarted;

  function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    onClick(task);
  }

  return (
    <div
      className={`${chipClass} ${statusClass}`}
      onClick={handleClick}
      title={task.name}
    >
      {task.priority && (
        <span className={`${styles.priorityDot} ${PRIORITY_DOT_CLASS[task.priority] ?? ""}`} />
      )}
      {task.name}
    </div>
  );
}
